import { IBaseMigrationStaffer } from '../../../interfaces';
import {
  STAFFER_MAPPING,
  StafferMappingHandler,
} from '../../../mappings/staff';
import {
  IOasisProvider,
  OasisProvider,
  ProviderSourceEntity,
} from '../../source/entities/providers';

export class OasisStafferMappingHandler extends StafferMappingHandler<
  OasisProvider,
  ProviderSourceEntity
> {
  override sourceEntity = new ProviderSourceEntity();
  override customMapping = {
    ...STAFFER_MAPPING,
    metadata: {
      ...STAFFER_MAPPING.metadata,
      allowManualInput: true,
    },
  };
  translateFn = (record: IOasisProvider): IBaseMigrationStaffer => {
    return {
      id: record.id,
      name: record.name,
      providerNo: record.providerNumber,
    };
  };
}
